import { Link } from "react-router-dom";
import { Pages } from "@/constants/enums";
import { appPath } from "@/constants/paths";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { WidgetContentSkeleton } from "@/components/shared/loading-skeleton";
import { Activity, ArrowLeft } from "lucide-react";
import type { HealthStatus } from "@/features/dashboard/services/healthService";
import { formatOptionalArabicDateTime } from "@/lib/formatters";

interface SystemHealthWidgetProps {
  data: HealthStatus | undefined;
  isLoading: boolean;
}

export function SystemHealthWidget({ data, isLoading }: SystemHealthWidgetProps) {
  const isHealthy = data?.status === "ok";

  return (
    <Card className="flex flex-col overflow-hidden" dir="rtl">
      <div className="accent-top-bar" />
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">صحة النظام</CardTitle>
          <div className="rounded-md bg-primary/10 p-1.5 text-primary">
            <Activity className="size-4" />
          </div>
        </div>
      </CardHeader>

      <CardContent className="flex-1 space-y-4">
        {isLoading ? (
          <WidgetContentSkeleton rows={2} />
        ) : (
          <>
            <div className="flex justify-start">
              <Badge variant={isHealthy ? "default" : "destructive"}>
                {isHealthy ? "متصل" : "غير متاح"}
              </Badge>
            </div>
            <div className="space-y-2 text-sm">
              <div className="flex items-center justify-between border-b border-border/60 py-1">
                <span className="text-muted-foreground">حالة API</span>
                <span className="font-medium text-foreground">
                  {data?.status ?? "—"}
                </span>
              </div>
              <div className="flex items-center justify-between py-1">
                <span className="text-muted-foreground">آخر فحص</span>
                <span className="font-medium text-foreground">
                  {formatOptionalArabicDateTime(data?.time)}
                </span>
              </div>
            </div>
          </>
        )}
      </CardContent>

      <CardFooter className="justify-start pt-0">
        <Link
          to={appPath(Pages.SETTINGS)}
          className="flex items-center gap-1 text-sm text-primary hover:text-primary/80"
        >
          الإعدادات
          <ArrowLeft className="size-4" />
        </Link>
      </CardFooter>
    </Card>
  );
}
